export default __webpack_public_path__ + "pgnv-assets/601d2d49d87a9f9ceee94b0040685ad3.png";